
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/dropdown",
      function () {
        return require("private-next-pages/components/dropdown.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/dropdown"])
      });
    }
  